var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleMaze = function SvgRectangleMaze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 364 1676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#RectangleMaze_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21 4h371.971A9.029 9.029 0 0 1 360 13.029v208.63a9.028 9.028 0 0 1-9.029 9.028H24.315a9.03 9.03 0 0 0-9.03 9.029v175.878a9.029 9.029 0 0 0 9.03 9.029H350.97a9.028 9.028 0 0 1 9.029 9.029V647.74a9.028 9.028 0 0 1-9.029 9.029H24.315a9.029 9.029 0 0 0-9.03 9.029v247.634a9.029 9.029 0 0 0 9.03 9.029H350.97A9.028 9.028 0 0 1 360 931.49v247.03c0 4.99-4.042 9.03-9.029 9.03H24.315a9.028 9.028 0 0 0-9.03 9.03v216.06c0 4.99 4.043 9.03 9.03 9.03H350.97a9.027 9.027 0 0 1 9.029 9.03v231.27c0 4.99-4.042 9.03-9.029 9.03H-21",
    stroke: "url(#RectangleMaze_svg__b)",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "RectangleMaze_svg__b",
    x1: 169.5,
    y1: 4,
    x2: 169.5,
    y2: 1996.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F82BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07D170"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "RectangleMaze_svg__a",
    x: -24.611,
    y: 0.993,
    width: 388.07,
    height: 1674.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.451,
    dy: 0.903
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.58
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2072_5900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2072_5900",
    result: "shape"
  })))));
};

export default SvgRectangleMaze;